<template>
  <nav>
    <!--[if lte IE 8]>
      <p class="chromeframe">
        You are using an <strong>outdated</strong> browser. Please
        <a href="http://browsehappy.com/">upgrade your browser</a>.
      </p>
    <![endif]-->
    <ul class="nav navbar justify-content-between align-items-center bg-white">
      <li class="nav-item">
        <a href="https://hungerhub.com/" id="logo">
          <!--<router-link to="hungerhub.com" id="logo"> -->
          <img
            src="../assets/img/uncatering_logo.png"
            alt="Uncatering"
            text-align="center"
            data-retina="true"
            class="logo d-sm-block mx-auto"
          />
          <!--</router-link> -->
        </a>
      </li>
    </ul>
    <div id="preloader">
      <div class="sk-spinner sk-spinner-wave" id="status">
        <div class="sk-rect1"></div>
        <div class="sk-rect2"></div>
        <div class="sk-rect3"></div>
        <div class="sk-rect4"></div>
        <div class="sk-rect5"></div>
      </div>
    </div>
    <!-- End Preload -->
  </nav>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
#logo img {
  margin-right: 50px;
}

ul li a {
  color: black;
  font-size: 14px;
  font-weight: 500;
  margin: 2px 0px;
}

ul li a:hover,
ul li a:focus {
  color: #ec008c;
  text-decoration: none;
  transition: all 0.2s ease;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue